// Pushes a "load more" event when the element scrolls into view, so a list grows without a
// click. Generic (not board-specific) — the event name comes from `data-load-more-event` and
// the prefetch distance from an optional `data-load-more-margin`. Any view can use it.
//
// The element is expected to be rendered only while a further page exists, so its removal IS
// the "no more results" signal; the hook keeps no completion state of its own.
//
// While a request is in flight it stamps `data-loading="true"` on itself, which lets CSS swap
// the trigger for a spinner with no server-side loading assign — LiveView's `handle_event` is
// synchronous, so a server flag would never get an intermediate render in which to paint.
const LoadMoreOnScroll = {
  mounted() {
    const event = this.el.dataset.loadMoreEvent;
    if (!event) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        // `pending` is released only by the pushEvent reply below. Without it the observer
        // keeps firing while the sentinel is still on screen and chain-loads every page.
        if (!entry.isIntersecting || this.pending) return;

        this.pending = true;
        this.el.dataset.loading = "true";

        this.pushEvent(event, {}, () => {
          this.pending = false;
          delete this.el.dataset.loading;
        });
      },
      // Viewport root works at both breakpoints: on desktop the sentinel is clipped by the
      // `overflow-y-auto` ancestor and only intersects once scrolled to; on mobile the aside
      // is not scrollable and ordinary page scroll applies.
      { rootMargin: this.el.dataset.loadMoreMargin || "200px" }
    );

    this.observer.observe(this.el);
  },

  destroyed() {
    this.observer?.disconnect();
  },
};

export default LoadMoreOnScroll;
